import { render, staticRenderFns } from "./exp.vue?vue&type=template&id=6484b8a8&"
import script from "./exp.vue?vue&type=script&lang=js&"
export * from "./exp.vue?vue&type=script&lang=js&"
import style0 from "./exp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports